// @flow

import * as React from 'react';
import { Breadcrumb, Divider } from 'antd';
import { NavLink } from 'react-router-dom';
import { getTeamUrl } from 'Common';

type Props = {
  project: any,
  mobileToggle?: any
}

export default (props: Props) => {

  const { project, mobileToggle } = props;

  return (

    <React.Fragment>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Breadcrumb separator="»">

        <Breadcrumb.Item>
          Home
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          <NavLink to={getTeamUrl("projects")}>
            Projects
          </NavLink>
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          {project.number}
        </Breadcrumb.Item>

        </Breadcrumb>

        {mobileToggle}
      </div>

      <Divider />

    </React.Fragment>

  )
}
